import { FormattedMessage } from "react-intl";
import ConfigService from "@/components/service/ConfigService.js";
import ErrorMessage from "@/components/FormElements/ErrorMessage.jsx";
import Button from "@/components/ui/Button.jsx";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import CSRFInput from "@/components/CSRFInput.jsx";

function SavePassword() {
  const principal = useSelector(state => state.authentication.principal);

  const configService = ConfigService.getInstance();
  const [searchParams, setSearchParams] = useSearchParams();

  const error = searchParams.get("error");
  const message = searchParams.get("message");


  return (
    <div className="600:w-[360px] mx-auto mt-12 flex flex-col pb-12 px-4">
      {
        error ? (
          <ErrorMessage error={error} />
        ) : message ? (
          <div className="mb-10">
            <p className="mb-5">{message}</p>
            <form
              action={configService.formulateContextPath("/signout")}
              method="POST"
            >
              <CSRFInput/>

              <Button className="mb-3 w-full" type="submit">
                <FormattedMessage id="template.signin" defaultMessage="Sign in" />
              </Button>
            </form>
          </div>
        ) : (
          <FormattedMessage
            id="auth.errorTitle"
            defaultMessage="Something went wrong!"
          />
        ) // maybe redirects to error.....
      }
    </div>
  );
}

export default SavePassword;
